export default __webpack_public_path__ + "static/media/phones.f8278133.png";